<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4" v-show="!loader">
          <div class="row align-items-center mb-4">
            <div class="col-md-4">
              <h2 class="page-title mb-md-0 mb-3">
                <a class="cursor-pointer" v-on:click="$router.go(-1)"
                  ><img
                    src="/images/back-arrow.svg"
                    width="20"
                    alt=""
                    class="me-2" /></a
                >Edit Profile
              </h2>
            </div>
            <div class="col-md-8 form-style d-flex justify-content-end"></div>
          </div>
          <Form @submit="update()">
            <div class="mb-4 form-style">
              <div class="border-bottom mb-2">
                <h4 class="font-medium">Personal Details</h4>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-4 col-6 mb-3">
                  <label class="mb-2" for="">First Name</label>
                  <Field
                    type="text"
                    name="first_name"
                    class="form-control gery-light"
                    placeholder="First Name"
                    @keypress="$helperService.maxInput($event, 15)"
                    @keyup="trimMaxLength('first_name', 15)"
                    v-model="detail.first_name"
                    rules="required:first name"
                    :validateOnInput="true" />
                  <ErrorMessage name="first_name" class="text-danger" />
                </div>

                <div class="col-lg-4 col-md-4 col-6 mb-3">
                  <label class="mb-2" for="">Middle Name</label>
                  <Field
                    type="text"
                    name="middle_name"
                    class="form-control gery-light"
                    @keypress="$helperService.maxInput($event, 15)"
                    @keyup="trimMaxLength('middle_name', 15)"
                    placeholder="Middle Name"
                    v-model="detail.middle_name" />
                  <!-- <ErrorMessage name="middle_name" class="text-danger" /> -->
                </div>
                <div class="col-lg-4 col-md-4 col-6 mb-3">
                  <label class="mb-2" for="">Last Name</label>
                  <Field
                    type="text"
                    name="last_name"
                    class="form-control"
                    placeholder="Last Name"
                    @keypress="$helperService.maxInput($event, 25)"
                    @keyup="trimMaxLength('last_name', 25)"
                    v-model="detail.last_name"
                    rules="required:last name"
                    :validateOnInput="true" />
                  <ErrorMessage name="last_name" class="text-danger" />
                </div>
                <!-- <p>
                      {{ detail.first_name ? detail.first_name : "" }}
                      {{ detail.middle_name }}
                      {{ detail.last_name ? detail.last_name : "" }}
                    </p> -->
                <!-- </div> -->
                <!-- </div> -->
                <div class="col-lg-4 col-md-4 col-6">
                  <label for="">Gender</label>
                  <span class="col-2 text-danger">*</span>
                  <div
                    class="d-flex"
                    style="margin-left: 23px; margin-top: 3px">
                    <div class="form-check p-0">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="genderType"
                        id="male1"
                        disabled
                        value="M"
                        v-model="detail.gender" />
                      <label class="form-check-label" for="male1">Male</label>
                    </div>
                    <div class="col-2 form-check" style="margin-left: 9px">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="genderType"
                        id="female1"
                        value="F"
                        disabled
                        v-model="detail.gender" />
                      <label class="form-check-label" for="female1">
                        Female
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-6">
                  <div class="form-group">
                    <label for="">Date Of Birth</label>
                    <span class="text-danger">*</span>
                    <CustomDatepicker
                      @update="changeBOD($event)"
                      :modelValue="detail.dob"
                      ref="dobDatePicker" />
                  </div>
                </div>
                <div class="col-md-4 col-6">
                  <div class="form-group">
                    <label for="">Marital Status</label>
                    <span class="text-danger">*</span>
                    <Field
                      as="select"
                      class="form-select form-control"
                      id="inputRole"
                      name="marrital_status"
                      v-model="detail.marital_status_id"
                      rules="required: marital status, true">
                      <option value="">Select Status</option>
                      <option
                        v-for="(data, index) in marriedStatusList"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                    <ErrorMessage name="marrital_status" class="text-danger" />
                  </div>
                </div>
                <div class="col-md-4 form-group" v-if="detail.family_details">
                  <label for="">Login Email</label>
                  <span class="text-danger">*</span>
                  <Field
                    type="email"
                    name="pesonalemail"
                    class="form-control"
                    placeholder="Email"
                    v-model="detail.email"
                    rules="required: Email|email"
                    :validateOnInput="true"
                    disabled />
                  <div
                    class="cursor-pointer"
                    style="margin-top: -35px; margin-left: 390px"
                    v-on:click="showMobilePopup('CHANGE_EMAIL')">
                    <i class="bx bxs-edit-alt"></i>
                  </div>
                  <ErrorMessage name="pesonalemail" class="text-danger" />
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Login Mobile Number</label>
                    <span class="text-danger">*</span>
                    <Field
                      type="text"
                      name="phone"
                      placeholder="Phone Number"
                      v-slot="{ field }"
                      v-model="detail.mobile"
                      class="form-control mobile_no"
                      rules="required:Mobile Number"
                      :validateOnInput="true">
                      <PhoneCode
                        id="mobile"
                        placeholder="Mobile Number"
                        v-model:countryCode="detail.country_code"
                        v-model="detail.mobile"
                        v-model:dialCode="detail.mobile_country_code"
                        v-bind="field"
                        disabled />
                      <div
                        class="cursor-pointer"
                        style="margin-top: -35px; margin-left: 390px"
                        v-on:click="showMobilePopup('CHANGE_NUMBER')">
                        <i class="bx bxs-edit-alt"></i>
                      </div>
                    </Field>
                  </div>
                  <ErrorMessage name="phone" class="validation-msg" />
                </div>
                <div class="col-md-4 mb-2 form-group">
                  <label for="">Height</label>
                  <span class="text-danger">*</span>
                  <Field
                    as="select"
                    class="form-control form-select"
                    placeholder="Select Height"
                    id="new_height"
                    name="new_height"
                    v-model="detail.height"
                    rules="required:Height"
                    :validateOnInput="true">
                    <option value="">Select Height</option>
                    <option :value="detail.height" v-if="detail.height">
                      {{ $helperService.getHeight(detail.height) }}
                    </option>
                    <option value="139">
                      {{ $helperService.getHeight(139) }}
                    </option>
                    <option value="142">
                      {{ $helperService.getHeight(142) }}
                    </option>
                    <option value="144">
                      {{ $helperService.getHeight(144) }}
                    </option>
                    <option value="147">
                      {{ $helperService.getHeight(147) }}
                    </option>
                    <option value="149">
                      {{ $helperService.getHeight(149) }}
                    </option>
                    <option value="152">
                      {{ $helperService.getHeight(152) }}
                    </option>
                    <option value="154">
                      {{ $helperService.getHeight(154) }}
                    </option>
                    <option value="157">
                      {{ $helperService.getHeight(157) }}
                    </option>
                    <option value="160">
                      {{ $helperService.getHeight(160) }}
                    </option>
                    <option value="162">
                      {{ $helperService.getHeight(162) }}
                    </option>
                    <option value="165">
                      {{ $helperService.getHeight(165) }}
                    </option>
                    <option value="167">
                      {{ $helperService.getHeight(167) }}
                    </option>
                    <option value="170">
                      {{ $helperService.getHeight(170) }}
                    </option>
                    <option value="172">
                      {{ $helperService.getHeight(172) }}
                    </option>
                    <option value="175">
                      {{ $helperService.getHeight(175) }}
                    </option>
                    <option value="177">
                      {{ $helperService.getHeight(177) }}
                    </option>
                    <option value="180">
                      {{ $helperService.getHeight(180) }}
                    </option>
                    <option value="182">
                      {{ $helperService.getHeight(182) }}
                    </option>
                    <option value="185">
                      {{ $helperService.getHeight(185) }}
                    </option>
                    <option value="187">
                      {{ $helperService.getHeight(187) }}
                    </option>
                    <option value="190">
                      {{ $helperService.getHeight(190) }}
                    </option>
                    <option value="192">
                      {{ $helperService.getHeight(192) }}
                    </option>
                    <option value="195">
                      {{ $helperService.getHeight(195) }}
                    </option>
                    <option value="198">
                      {{ $helperService.getHeight(198) }}
                    </option>
                    <option value="200">
                      {{ $helperService.getHeight(200) }}
                    </option>
                    <option value="203">
                      {{ $helperService.getHeight(203) }}
                    </option>
                    <option value="205">
                      {{ $helperService.getHeight(205) }}
                    </option>
                    <option value="208">
                      {{ $helperService.getHeight(208) }}
                    </option>
                    <option value="210">
                      {{ $helperService.getHeight(210) }}
                    </option>
                    <option value="213">
                      {{ $helperService.getHeight(213) }}
                    </option>
                  </Field>
                  <ErrorMessage name="new_height" class="text-danger" />
                </div>
                <div class="col-md-4 mb-2">
                  <div class="form-group">
                    <label>Native Gaon</label>
                    <!-- <span class="text-danger">*</span> -->
                    <Field
                      type="text"
                      name="native_place222"
                      class="form-control gery-dark"
                      placeholder="Native Gaon"
                      @keypress="$helperService.maxInput($event, 12)"
                      @keyup="trimMaxLength('native_place_goan', 12)"
                      v-model="detail.native_place_goan" />
                  </div>
                </div>
                <div class="col-md-4 mb-2 form-group">
                  <label for="">Native Taluka</label>
                  <!-- <span class="text-danger">*</span> -->
                  <Field
                    as="select"
                    class="form-select form-control gery-dark"
                    id="native_place"
                    name="native_place_taluka"
                    v-model="detail.native_place_taluka_id">
                    <option value="">Select Taluka</option>
                    <option
                      v-for="(data, index) in nativeTalukaList"
                      :key="index"
                      :value="data.uuid">
                      {{ data.name }}
                    </option>
                  </Field>
                  <!-- <ErrorMessage
                              name="native_place_taluka"
                              class="text-danger"
                            /> -->
                </div>
                <div class="col-md-4 mb-2 form-group">
                  <label for="">Native District</label>
                  <span class="text-danger">*</span>

                  <Field
                    as="select"
                    class="form-control form-select"
                    id="native_district"
                    name="native_place_district"
                    v-model="detail.native_place_district_id"
                    rules="required: district">
                    <option value="">Select District</option>
                    <option
                      v-for="(data, index) in district"
                      :key="index"
                      :value="data.uuid">
                      {{ data.name }}
                    </option>
                  </Field>
                  <ErrorMessage
                    name="native_place_district"
                    class="text-danger" />
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Body Structure</label>
                    <!-- <span class="text-danger">*</span> -->
                    <Field
                      as="select"
                      aria-describedat=""
                      class="form-select form-control"
                      id="body_structure"
                      name="body_structure"
                      v-model="detail.body_structure_id">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in body_structure"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                    <!-- <ErrorMessage name="body_structure" class="text-danger" /> -->
                  </div>
                </div>
                <div class="col-md-4 mb-2 form-group">
                  <label for="">Blood Group</label>
                  <!-- <span class="text-danger">*</span> -->
                  <Field
                    as="select"
                    class="form-control form-select"
                    id="blood_group"
                    name="blood_group"
                    v-model="detail.blood_group">
                    <option value="">Select</option>
                    <option value="A +ve">A +ve</option>
                    <option value="A -ve">A -ve</option>
                    <option value="B +ve">B +ve</option>
                    <option value="B -ve">B -ve</option>
                    <option value="O +ve">O +ve</option>
                    <option value="O -ve">O -ve</option>
                    <option value="AB +ve">AB +ve</option>
                    <option value="AB -ve">AB -ve</option>
                  </Field>
                  <!-- <ErrorMessage name="blood_group" class="text-danger" /> -->
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Skin Tone</label>
                    <!-- <span class="text-danger">*</span> -->
                    <Field
                      as="select"
                      aria-describedat=""
                      class="form-select form-control"
                      id="skin_tone"
                      name="skin_tone"
                      v-model="detail.scan_tone_id">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in skin_tone"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                    <!-- <ErrorMessage name="skin_tone" class="text-danger" /> -->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Diet</label>
                    <!-- <span class="text-danger">*</span> -->
                    <Field
                      as="select"
                      class="form-select form-control"
                      id="diet"
                      name="diet"
                      v-model="detail.diet_id">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in diet"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                    <!-- <ErrorMessage name="diet" class="text-danger" /> -->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Education/Course</label>
                    <span class="text-danger">*</span>
                    <Field
                      as="textarea"
                      name="education_courses"
                      class="form-control"
                      placeholder="Education/Courses"
                      v-model="detail.education_courses"
                      @keypress="$helperService.maxInput($event, 135)"
                      @keyup="trimMaxLength('education_courses', 135)"
                      rules="required: education courses"
                      :validateOnInput="true" />
                    <ErrorMessage
                      name="education_courses"
                      class="text-danger" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Education Group</label>
                    <span class="text-danger">*</span>
                    <Field
                      as="select"
                      class="form-select form-control"
                      id="education_group"
                      name="education_group"
                      rules="required:education group, true"
                      v-model="detail.education_group_id"
                      :validateOnInput="true">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in education_group"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                    <ErrorMessage name="education_group" class="text-danger" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Occupation Type</label>
                    <!-- <span class="text-danger">*</span> -->
                    <Field
                      as="select"
                      class="form-select form-control"
                      id="occupation_type"
                      name="occupation_type"
                      v-model="detail.occupation_type_id">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in occupation_type"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                    <!-- <ErrorMessage name="occupation_type" class="text-danger" /> -->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Occupation Detail</label>
                    <Field
                      type="text"
                      name="occupation_details"
                      class="form-control"
                      placeholder="Occupation Detail"
                      @keypress="$helperService.maxInput($event, 48)"
                      @keyup="trimMaxLength('occupation_details', 48)"
                      v-model="detail.occupation_details" />
                    <!-- <ErrorMessage
                      name="occupation_details"
                      class="text-danger" /> -->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Annual Income (Rs)</label>
                    <span class="text-danger">*</span>
                    <Field
                      type="text"
                      name="annual_income"
                      class="form-control"
                      placeholder="Income"
                      v-model="detail.annual_income"
                      v-on:keypress="
                        $helperService.allowOnlyNumericValue($event)
                      "
                      rules="required:annual income"
                      :validateOnInput="true" />
                    <ErrorMessage name="annual_income" class="text-danger" />
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="">Work Location</label>
                  <div class="d-flex">
                    <Field
                      as="select"
                      id="taluka"
                      name="taluka"
                      class="form-select form-control me-2"
                      v-model="detail.working_place_taluka_id">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in work_location"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                  </div>
                  <ErrorMessage name="taluka" class="text-danger" />
                </div>
                <div class="col-md-4 form-group">
                  <label for=""></label>
                  <div class="d-flex">
                    <Field
                      type="text"
                      class="form-control gery-dark"
                      name="working_place_goan"
                      @keypress="$helperService.maxInput($event, 20)"
                      @keyup="trimMaxLength('working_place_goan', 20)"
                      placeholder="Area/Gaon"
                      v-model="detail.working_place_goan" />
                  </div>
                  <!-- <ErrorMessage name="working_place_goan" class="text-danger" /> -->
                </div>
                <div class="col-md-4">
                  <div class="">
                    <label for="">Birth Time & Birth District</label>
                    <div class="d-flex">
                      <Datepicker
                        class="form-control me-2"
                        name="birth_time"
                        autoApply
                        placeholder="Select Time"
                        :is-24="false"
                        v-model="detail.birth_time"
                        timePicker />
                      <!-- <ErrorMessage name="birth_time" class="text-danger" /> -->
                      <Field
                        as="select"
                        class="form-select form-control"
                        id="birth_district"
                        name="birth_district"
                        v-model="detail.birth_district_id">
                        <option value="">Select</option>
                        <option
                          :value="data.uuid"
                          v-for="(data, index) in district"
                          :key="index">
                          {{ data.name }}
                        </option>
                      </Field>
                      <!-- <ErrorMessage name="birth_district" class="text-danger" /> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Mangal</label>
                    <Field
                      as="select"
                      id="is_mangal"
                      name="is_mangal"
                      class="form-select form-control"
                      v-model="detail.is_mangal">
                      <option value="">Select</option>
                      <option value="N">No</option>
                      <option value="Y">Yes</option>
                      <option value="SOUMYA">Soumya</option>
                      <option value="NIRDOSH">Nirdosh</option>
                      <option value="NOT_KNOWN">Not Known</option>
                      <option value="NO,">No,</option>
                    </Field>
                    <!-- <ErrorMessage name="is_mangal" class="text-danger" /> -->
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 mb-2 form-group">
                  <label for="">Horoscope Details </label>
                </div>
                <div class="col-lg-10 col-md-12 row">
                  <div class="col-3 form-group">
                    <label for="">Rashi</label>
                    <div class="d-flex">
                      <Field
                        as="select"
                        id="raas_id"
                        name="raas_id"
                        class="form-select form-control"
                        v-model="detail.raas_id">
                        <option value="">Select</option>
                        <option
                          v-for="(data, index) in raas"
                          :key="index"
                          :value="data.uuid">
                          {{ data.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-4 form-group">
                    <label for="">Nakshatra</label>
                    <div class="d-flex">
                      <Field
                        as="select"
                        id="nakshatra"
                        name="nakshatra"
                        v-on:change="getCharan(detail.nakshatra_id)"
                        class="form-select form-control me-2"
                        v-model="detail.nakshatra_id">
                        <option value="">Select</option>
                        <option
                          v-for="(data, index) in nakshatra"
                          :key="index"
                          :value="data.uuid">
                          {{ data.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-2 form-group">
                    <label for="">Charan</label>
                    <div class="d-flex">
                      <Field
                        as="select"
                        id="charan"
                        name="charan"
                        class="form-select form-control me-2"
                        v-model="detail.charan_id">
                        <option value="">Select</option>
                        <option
                          v-for="(data, index) in charan"
                          :key="index"
                          :value="data.uuid">
                          {{ data.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-3 form-group">
                    <label for="">Gan</label>
                    <div class="d-flex">
                      <Field
                        as="select"
                        id="gan"
                        name="gan"
                        class="form-select form-control me-2"
                        v-model="detail.gan_id">
                        <option value="">Select</option>
                        <option
                          v-for="(data, index) in gan"
                          :key="index"
                          :value="data.uuid">
                          {{ data.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label for="">Nadi</label>
                  <div class="d-flex">
                    <Field
                      as="select"
                      id="nadi"
                      name="nadi"
                      class="form-select form-control me-2"
                      v-model="detail.nadi_id">
                      <option value="">Select</option>
                      <option
                        v-for="(data, index) in nadi"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </Field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Devak</label>
                    <Field
                      as="select"
                      class="form-select form-control"
                      id="devak"
                      name="devak"
                      v-model="detail.devak_id">
                      <option value="">Select Devak</option>
                      <option
                        v-for="(data, index) in devakList"
                        :key="index"
                        :value="data.id">
                        {{ data.name }}
                      </option>
                    </Field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Ready to Move Abroad?</label>
                    <Field
                      as="select"
                      id="abroad"
                      name="abroad"
                      class="form-select form-control"
                      v-model="detail.ready_to_move_abrod">
                      <option value="">Select</option>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                      <option value="UNDECIDED">Undecided</option>
                      <option value="ALREADY_IN">Already in</option>
                    </Field>
                    <!-- <ErrorMessage name="abroad" class="text-danger" /> -->
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="d-md-flex">
                    <div class="form-group md-6 col">
                      <label for="">Other Information</label>

                      <Field
                        type="text"
                        name="other_info"
                        class="form-control"
                        @keypress="$helperService.maxInput($event, 45)"
                        @keyup="trimMaxLength('other_info', 45)"
                        placeholder="Other Information"
                        v-model="detail.other_info" />
                      <!-- <ErrorMessage name="other_info" class="text-danger" /> -->
                    </div>
                  </div>
                </div>

                <div class="border-bottom mb-3">
                  <h4 class="font-medium">Family Details</h4>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" v-if="detail.family_details">
                      <label for="">Contact Full Name</label>
                      <!-- <span class="text-danger">*</span> -->
                      <Field
                        type="text"
                        name="contact_full_name"
                        class="form-control gery-light"
                        @keypress="$helperService.maxInput($event, 55)"
                        @keyup="
                          trimMaxLength('family_details.contact_full_name', 55)
                        "
                        placeholder="Contact Full Name"
                        v-model="detail.family_details.contact_full_name" />
                      <!-- <ErrorMessage
                        name="contact_full_name"
                        class="text-danger" /> -->
                    </div>
                  </div>

                  <div class="col-md-8">
                    <div>
                      <div class="form-group" v-if="detail.family_details">
                        ``
                        <label for="">Address</label>

                        <Field
                          type="text"
                          name="address"
                          class="form-control gery-light"
                          placeholder="Address"
                          @keypress="$helperService.maxInput($event, 60)"
                          @keyup="trimMaxLength('family_details.address', 60)"
                          v-model="detail.family_details.address" />
                        <!-- <ErrorMessage name="address" class="text-danger" /> -->
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 row">
                    <div
                      class="col-md-3 form-group"
                      v-if="detail.family_details">
                      <label for="">Area/Gaon</label>
                      <Field
                        type="text"
                        name="goan"
                        class="form-control gery-light"
                        @keypress="$helperService.maxInput($event, 20)"
                        @keyup="trimMaxLength('family_details.goan', 20)"
                        placeholder="Area/Gaon"
                        v-model="detail.family_details.goan"
                        rules=": Area/Gaon"
                        :validateOnInput="true" />
                      <ErrorMessage name="goan" class="text-danger" />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="">Taluka</label>
                      <div class="">
                        <Field
                          as="select"
                          class="form-control form-select gery-light"
                          id="taluka1"
                          name="taluka1"
                          v-model="detail.family_details.taluka_id">
                          <option value="">Select Taluka</option>
                          <option
                            v-for="(data, index) in taluka"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                      </div>
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="">District</label>
                      <div class="">
                        <Field
                          as="select"
                          class="form-control form-select gery-light"
                          id="district"
                          name="district"
                          v-model="detail.family_details.district_id">
                          <option value="">Select District</option>
                          <option
                            v-for="(data, index) in district"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                      </div>
                    </div>

                    <div class="col-md-3 form-group" style="display: none">
                      <label for="">State</label>
                      <div class="">
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="state"
                          name="state"
                          v-model="detail.family_details.state_id">
                          <option value="">Select State</option>
                          <option
                            v-for="(data, index) in stateList"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div
                      class="form-group col-12 d-flex row"
                      v-if="detail.family_details">
                      <label for="">Father Occupation</label>
                      <div class="col-6">
                        <Field
                          type="text"
                          name="father_occupation"
                          class="form-control me-3"
                          @keypress="$helperService.maxInput($event, 30)"
                          @keyup="
                            trimMaxLength('family_details.father_occuption', 30)
                          "
                          placeholder="Occupation"
                          v-model="detail.family_details.father_occuption" />
                        <!-- <ErrorMessage name="father_occupation" class="text-danger" /> -->
                      </div>
                      <div class="col-6">
                        <Field
                          type="text"
                          name="father_place"
                          class="form-control gery-dark"
                          @keypress="$helperService.maxInput($event, 20)"
                          @keyup="
                            trimMaxLength(
                              'family_details.father_occuption_place',
                              20
                            )
                          "
                          placeholder="Place"
                          v-model="
                            detail.family_details.father_occuption_place
                          " />
                        <!-- <ErrorMessage name="father_place" class="text-danger" /> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div
                      class="form-group col-12 d-flex row"
                      v-if="detail.family_details">
                      <label for="">Mother Occupation</label>

                      <div class="col-6">
                        <Field
                          type="text"
                          name="mother_occupation"
                          class="form-control me-3"
                          placeholder="Occupation"
                          @keypress="$helperService.maxInput($event, 20)"
                          @keyup="
                            trimMaxLength('family_details.mother_occuption', 20)
                          "
                          v-model="detail.family_details.mother_occuption" />
                        <!-- <ErrorMessage name="mother_occupation" class="text-danger" /> -->
                      </div>
                      <div class="col-6">
                        <Field
                          type="text"
                          name="mother_place"
                          class="form-control gery-dark"
                          @keypress="$helperService.maxInput($event, 20)"
                          @keyup="
                            trimMaxLength(
                              'family_details.mother_occuption_place',
                              20
                            )
                          "
                          placeholder="Place"
                          v-model="
                            detail.family_details.mother_occuption_place
                          " />
                        <!-- <ErrorMessage name="mother_place" class="text-danger" /> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-if="detail.family_details">
                      <label for="">Email</label>
                      <Field
                        type="email"
                        name="email"
                        class="form-control gery-light"
                        @keypress="$helperService.maxInput($event, 32)"
                        @keyup="trimMaxLength('family_details.email', 32)"
                        placeholder="Email"
                        v-model="detail.family_details.email" />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="">Phone by Priority</label>
                  <!-- <span class="text-danger">*</span> -->
                  <div
                    class="d-flex mb-2"
                    v-for="(data, index) in detail.family_details
                      .familty_phone_numbers"
                    :key="index">
                    <Field
                      as="select"
                      class="form-control mr-2 gery-light"
                      :id="'inputRole_' + index"
                      :name="'type_' + index"
                      v-model="data.type">
                      <option value="">Select</option>
                      <option value="FATHER">Father</option>
                      <option value="MOTHER">Mother</option>
                      <option value="CANDIDATE">Candidate</option>
                      <option value="BROTHER">Brother</option>
                      <option value="SISTER">Sister</option>
                      <option value="KAKA">Kaka</option>
                      <option value="KAKI">Kaki</option>
                      <option value="MAMA">Mama</option>
                      <option value="MAMI">Mami</option>
                      <option value="MAVSHI">Mavshi</option>
                      <option value="AATTYA">Aattya</option>
                      <option value="COUSIN_BROTHER">Cousin Brother</option>
                      <option value="COUSINE_SISTER">Cousin Sister</option>
                      <option value="FRIEND">Friend</option>
                      <option value="OTHER">Other</option>
                    </Field>
                    <!-- <ErrorMessage :name="'type_' + index" class="text-danger" /> -->
                    <div class="col-6" style="margin-left: 10px">
                      <Field
                        type="text"
                        class="form-control mr-2 gery-light"
                        id="inputRole"
                        :name="'family_phone_numbers_phone_' + index"
                        v-model="data.phone"
                        v-on:keypress="
                          $helperService.allowOnlyNumericWithOperaterValue(
                            $event
                          )
                        " />
                      <!-- <ErrorMessage
                        :name="'family_phone_numbers_phone_' + index"
                        class="text-danger"
                      /> -->
                    </div>
                    <span
                      :name="'whatsapp_' + index"
                      v-on:click="updateWhatsappFlag(data)"
                      :style="
                        data.is_whatsapp == 'Y'
                          ? 'opacity: 1;margin-top: 6px;'
                          : 'opacity: 0.5;margin-top: 6px;'
                      "
                      class="h5 text-success mr-2 cursor-pointer"
                      ><i class="bx bxl-whatsapp"></i
                    ></span>
                    <span
                      :name="'phone_' + index"
                      v-on:click="updateCallFlag(data)"
                      :style="
                        data.is_phone == 'Y'
                          ? 'opacity: 1;margin-top: 6px;'
                          : 'opacity: 0.5;margin-top: 6px;'
                      "
                      class="h5 cursor-pointer"
                      ><i class="bx bxs-phone"></i
                    ></span>
                  </div>
                </div>
                <p
                  class="mb-3 text-dark mt-3"
                  style="font-size: 15px; font-weight: 500">
                  Brother/Sisters Details (If sister is married, mention surname
                  only)
                </p>
                <div class="table-responsive">
                  <table
                    class="table table-style-1 table-bordered table-responsive">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Married?</th>
                        <th>Education</th>
                        <th>Occupation</th>
                        <th>Place</th>
                        <th>Birth Year</th>
                        <th>Height</th>
                        <th>Rel.</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="detail.family_details.family_members != null">
                      <tr
                        class="gery-dark"
                        v-for="(data, index) in detail.family_details
                          .family_members"
                        :key="index">
                        <td>{{ data.name ? data.name : "-" }}</td>
                        <td>
                          {{
                            data.is_married
                              ? data.is_married == "Y"
                                ? "Yes"
                                : "No"
                              : "-"
                          }}
                        </td>
                        <td>{{ data.education ? data.education : "-" }}</td>
                        <td>{{ data.occupation ? data.occupation : "-" }}</td>
                        <td>
                          {{ data.working_place ? data.working_place : "-" }}
                        </td>

                        <td>{{ data.birth_year ? data.birth_year : "-" }}</td>
                        <td>
                          {{
                            data.height
                              ? $helperService.getHeight(data.height)
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            data.gender
                              ? data.gender == "M"
                                ? "Bro"
                                : "Sis"
                              : "-"
                          }}
                        </td>
                        <td>
                          <a
                            v-on:click="editBrotherSister(index)"
                            href="javascript:void(0)"
                            class="mr-2 text-dark"
                            ><i class="bx bxs-edit-alt"></i
                          ></a>
                          <a
                            v-on:click="removeBrotherSister(index)"
                            class="mr-2 text-danger"
                            ><i class="bx bx-trash"></i
                          ></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="text-end"
                  v-if="detail?.family_details?.family_members.length < 3">
                  <a
                    href="javascript:void(0)"
                    data-bs-toggle="modal"
                    data-bs-target="#AddProperties">
                    <svg
                      v-on:click="showBrotherSisterPopup()"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="currentColor"
                      class="bi bi-plus-square-fill"
                      viewBox="0 0 16 16">
                      <path
                        d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                    </svg>
                  </a>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" v-if="detail.family_details">
                      <label for="">Mama Surname</label>
                      <Field
                        type="text"
                        name="mama_surname"
                        @keypress="$helperService.maxInput($event, 25)"
                        @keyup="
                          trimMaxLength('family_details.mama_surname', 25)
                        "
                        class="form-control"
                        placeholder="Mama Surname"
                        v-model="detail.family_details.mama_surname" />
                      <!-- <ErrorMessage name="mama_surname" class="text-danger" /> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-if="detail.family_details">
                      <label for="">Mama Native Gaon</label>
                      <Field
                        type="text"
                        name="mama_native_place"
                        @keypress="$helperService.maxInput($event, 20)"
                        @keyup="
                          trimMaxLength('family_details.mama_native_place', 20)
                        "
                        class="form-control gery-dark"
                        placeholder="Mama Native Gaon"
                        v-model="detail.family_details.mama_native_place" />
                      <!-- <ErrorMessage name="mama_native_place" class="text-danger" /> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-if="detail.family_details">
                      <label for="">Mama Native Taluka</label>
                      <Field
                        type="text"
                        name="mama_taluka_place"
                        class="form-control"
                        placeholder="Mama Native Taluka"
                        @keypress="$helperService.maxInput($event, 20)"
                        @keyup="
                          trimMaxLength('family_details.mama_taluka_place', 20)
                        "
                        v-model="detail.family_details.mama_taluka_place" />
                      <!-- <ErrorMessage name="mama_taluka_place" class="text-danger" /> -->
                    </div>
                  </div>
                  <div class="col-12 row">
                    <div class="form-group mb-0">
                      <label class="font-medium">Relatives</label>
                    </div>
                    <div
                      class="col-md-4 d-flex mb-2"
                      v-for="(data, index) in detail.family_details.relatives"
                      :key="index">
                      <Field
                        type="text"
                        class="form-control me-2"
                        :id="'surname_' + index"
                        @keypress="$helperService.maxInput($event, 14)"
                        @keyup="trimMaxLengthGlobal('surname_' + index,14)"
                        placeholder="Surname"
                        :name="'surname_' + index"
                        v-model="data.surname" />
                      <Field
                        type="text"
                        class="form-control mr-2 gery-dark"
                        @keypress="$helperService.maxInput($event, 14)"
                        @keyup="trimMaxLengthGlobal('gaon_' + index,14)"
                        :id="'gaon_' + index"
                        placeholder="Gaon"
                        :name="'gaon_' + index"
                        v-model="data.goan" />
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="border-bottom mb-3">
                      <h4 class="font-medium">Properties Details</h4>
                    </div>

                    <div data-v-5440d88c="" class="row mb-3">
                      <div data-v-5440d88c="" class="col-md-10 bg-light py-1">
                        Properties, Flat, Land, Business, Vehicle Details
                      </div>
                      <div
                        data-v-5440d88c=""
                        class="col-md-2 bg-light py-1 px-1">
                        Property Details
                      </div>
                      <!-- <div
                        data-v-5440d88c=""
                        class="col-md-2 bg-light text-end">
                        <a
                          href="javascript:void(0)"
                          data-bs-toggle="modal"
                          data-bs-target="#AddProperties">
                          <svg
                            v-on:click="showPropertiesPopup()"
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            fill="currentColor"
                            class="bi bi-plus-square-fill"
                            viewBox="0 0 16 16">
                            <path
                              d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                          </svg>
                        </a>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="row mb-3"
                      v-for="(data, index) in detail.user_properties"
                      :key="index">
                      <div class="col-md-10">
                        <Field
                          type="text"
                          class="form-control"
                          :index="'details_' + index"
                          :id="'property_' + index"
                          :name="'property_' + index"
                          @keypress="$helperService.maxInput($event, 68)"
                          @keyup="trimMaxLengthGlobal('property_' + index,68)"
                          placeholder="Property"
                          v-model="data.details" />
                      </div>
                      <div class="col-md-2">
                        <Field
                          type="text"
                          :name="'place_' + index"
                          :id="'place_' + index"
                          :index="'place_' + index"
                          class="form-control gery-dark"
                          placeholder="Place"
                          @keypress="$helperService.maxInput($event, 10)"
                          @keyup="trimMaxLengthGlobal('place_' + index,10)"
                          v-model="data.place" />
                      </div>
                      <!-- <div class="col-lg-1">
                        <img
                          v-on:click="removevideoObj(data, index)"
                          src="/img/cross.png"
                          width="30"
                          height="30" />
                      </div> -->
                    </div>
                    <!-- <div class="text-end">
                     
                    </div> -->
                  </div>
                </div>

                <div class="border-bottom mb-3">
                  <h4 class="font-medium">Expectation</h4>
                </div>
                <div class="row">
                  <div class="col-md-4 form-group">
                    <label for="">Expected Marital Status</label>
                    <!-- <span class="text-danger">*</span> -->
                    <Multiselect
                      mode="tags"
                      :searchable="true"
                      name="marrital_status"
                      v-model="detail.expectation.marital_status"
                      trackBy="name"
                      label="name"
                      valueProp="uuid"
                      :options="marriedStatusList"
                      placeholder="Expected Marital Status"
                      object="true" />
                    <!-- <ErrorMessage name="marrital_status" class="text-danger" /> -->
                  </div>

                  <div class="col-md-6 form-group" style="display: none">
                    <!-- <label for="">Occupation</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="occupation_type"
                        v-model="detail.expectation.occupation_type"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="occupationTypeList"
                        placeholder="Occupation"
                        object="true"
                      /> 
                    </div>-->
                  </div>
                  <!-- <div class="col-md-6 form-group">
                    <label for="">Body Structure</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="body_structure"
                        v-model="detail.expectation.body_structure"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="body_structure"
                        placeholder="Body Structure"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 form-group">
                    <label for="">Diet</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="diet"
                        v-model="detail.expectation.diet"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="diet"
                        placeholder="Diet"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <div class="col-md-4 form-group">
                    <label for="">Expected Birth Years</label>
                    <div class="d-flex align-items-center">
                      <Datepicker
                        autoApply
                        placeholder="Select Year"
                        v-model="detail.expectation.birth_year_from"
                        :minDate="detail.expectation.birth_year_from"
                        yearPicker />
                      <label class="mb-0 mx-1">To</label>
                      <Datepicker
                        autoApply
                        placeholder="Select Year"
                        v-model="detail.expectation.birth_year_to"
                        :maxDate="new Date()"
                        yearPicker />
                    </div>
                  </div>
                  <div class="col-md-4 form-group">
                    <label for="">Expected Height</label>
                    <div class="d-flex align-items-center">
                      <Field
                        as="select"
                        class="form-control form-select"
                        id="height_from"
                        name="height_from"
                        v-model="detail.expectation.height_from">
                        <option value="">Select Height</option>
                        <option value="139">
                          {{ $helperService.getHeight(139) }}
                        </option>
                        <option value="142">
                          {{ $helperService.getHeight(142) }}
                        </option>
                        <option value="144">
                          {{ $helperService.getHeight(144) }}
                        </option>
                        <option value="147">
                          {{ $helperService.getHeight(147) }}
                        </option>
                        <option value="149">
                          {{ $helperService.getHeight(149) }}
                        </option>
                        <option value="152">
                          {{ $helperService.getHeight(152) }}
                        </option>
                        <option value="154">
                          {{ $helperService.getHeight(154) }}
                        </option>
                        <option value="157">
                          {{ $helperService.getHeight(157) }}
                        </option>
                        <option value="160">
                          {{ $helperService.getHeight(160) }}
                        </option>
                        <option value="162">
                          {{ $helperService.getHeight(162) }}
                        </option>
                        <option value="165">
                          {{ $helperService.getHeight(165) }}
                        </option>
                        <option value="167">
                          {{ $helperService.getHeight(167) }}
                        </option>
                        <option value="170">
                          {{ $helperService.getHeight(170) }}
                        </option>
                        <option value="172">
                          {{ $helperService.getHeight(172) }}
                        </option>
                        <option value="175">
                          {{ $helperService.getHeight(175) }}
                        </option>
                        <option value="177">
                          {{ $helperService.getHeight(177) }}
                        </option>
                        <option value="180">
                          {{ $helperService.getHeight(180) }}
                        </option>
                        <option value="182">
                          {{ $helperService.getHeight(182) }}
                        </option>
                        <option value="185">
                          {{ $helperService.getHeight(185) }}
                        </option>
                        <option value="187">
                          {{ $helperService.getHeight(187) }}
                        </option>
                        <option value="190">
                          {{ $helperService.getHeight(190) }}
                        </option>
                        <option value="192">
                          {{ $helperService.getHeight(192) }}
                        </option>
                        <option value="195">
                          {{ $helperService.getHeight(195) }}
                        </option>
                        <option value="198">
                          {{ $helperService.getHeight(198) }}
                        </option>
                        <option value="200">
                          {{ $helperService.getHeight(200) }}
                        </option>
                        <option value="203">
                          {{ $helperService.getHeight(203) }}
                        </option>
                        <option value="205">
                          {{ $helperService.getHeight(205) }}
                        </option>
                        <option value="208">
                          {{ $helperService.getHeight(208) }}
                        </option>
                        <option value="210">
                          {{ $helperService.getHeight(210) }}
                        </option>
                        <option value="213">
                          {{ $helperService.getHeight(213) }}
                        </option>
                      </Field>
                      <label class="mb-0 mx-1">To</label>
                      <Field
                        as="select"
                        class="form-control form-select"
                        id="height_to"
                        name="height_to"
                        v-model="detail.expectation.height_to">
                        <option value="">Select Height</option>
                        <option value="139">
                          {{ $helperService.getHeight(139) }}
                        </option>
                        <option value="142">
                          {{ $helperService.getHeight(142) }}
                        </option>
                        <option value="144">
                          {{ $helperService.getHeight(144) }}
                        </option>
                        <option value="147">
                          {{ $helperService.getHeight(147) }}
                        </option>
                        <option value="149">
                          {{ $helperService.getHeight(149) }}
                        </option>
                        <option value="152">
                          {{ $helperService.getHeight(152) }}
                        </option>
                        <option value="154">
                          {{ $helperService.getHeight(154) }}
                        </option>
                        <option value="157">
                          {{ $helperService.getHeight(157) }}
                        </option>
                        <option value="160">
                          {{ $helperService.getHeight(160) }}
                        </option>
                        <option value="162">
                          {{ $helperService.getHeight(162) }}
                        </option>
                        <option value="165">
                          {{ $helperService.getHeight(165) }}
                        </option>
                        <option value="167">
                          {{ $helperService.getHeight(167) }}
                        </option>
                        <option value="170">
                          {{ $helperService.getHeight(170) }}
                        </option>
                        <option value="172">
                          {{ $helperService.getHeight(172) }}
                        </option>
                        <option value="175">
                          {{ $helperService.getHeight(175) }}
                        </option>
                        <option value="177">
                          {{ $helperService.getHeight(177) }}
                        </option>
                        <option value="180">
                          {{ $helperService.getHeight(180) }}
                        </option>
                        <option value="182">
                          {{ $helperService.getHeight(182) }}
                        </option>
                        <option value="185">
                          {{ $helperService.getHeight(185) }}
                        </option>
                        <option value="187">
                          {{ $helperService.getHeight(187) }}
                        </option>
                        <option value="190">
                          {{ $helperService.getHeight(190) }}
                        </option>
                        <option value="192">
                          {{ $helperService.getHeight(192) }}
                        </option>
                        <option value="195">
                          {{ $helperService.getHeight(195) }}
                        </option>
                        <option value="198">
                          {{ $helperService.getHeight(198) }}
                        </option>
                        <option value="200">
                          {{ $helperService.getHeight(200) }}
                        </option>
                        <option value="203">
                          {{ $helperService.getHeight(203) }}
                        </option>
                        <option value="205">
                          {{ $helperService.getHeight(205) }}
                        </option>
                        <option value="208">
                          {{ $helperService.getHeight(208) }}
                        </option>
                        <option value="210">
                          {{ $helperService.getHeight(210) }}
                        </option>
                        <option value="213">
                          {{ $helperService.getHeight(213) }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <!-- <div class="col-md-12 mb-2 form-group">
                    <label for="">Education Group</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="expectation_education_group"
                        v-model="detail.expectation.education_group"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="educationGroupList"
                        placeholder="Education Group"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <div class="col-md-6 form-group">
                    <label for="">Patrika Matching</label>
                    <div class="">
                      <Field
                        as="select"
                        class="form-control form-select"
                        id="patrika_match"
                        name="patrika_match"
                        v-model="detail.expectation.patrika_match">
                        <option value="">Select Patrika Match</option>
                        <option value="ALL">Flexible</option>
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                      </Field>
                    </div>
                  </div>
                  <!-- <div class="col-md-6 form-group">
                    <label for="">Move to Abroad</label>
                    
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="move_to_abroad"
                        v-model="detail.expectation.move_to_abroad"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="moveToAbroadList"
                        placeholder="Move to Abroad"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 mb-2 form-group">
                    <label for="">Preferred Work Location</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="working_city"
                        v-model="detail.expectation.working_city"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="work_location"
                        placeholder="Select Preferred Work Location"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 mb-2 form-group">
                    <label for="">Preferred Native Places</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="native_district"
                        v-model="detail.expectation.native_district"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="districtList"
                        placeholder="Select Preferred Native Places"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 mb-2 form-group">
                    <label for="">Preferred Working Country</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="working_country"
                        v-model="detail.expectation.working_country"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="countryList"
                        placeholder="Select Country"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 mb-2 form-group">
                    <label for="">Family Residencial Taluka</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="nativeTalukaList"
                        v-model="detail.expectation.family_residence"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="nativeTalukaList"
                        placeholder="Select family residence"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-4 mb-2 form-group">
                    <label for="">Per.</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="personality"
                        v-model="detail.expectation.personality"
                        trackBy="name"
                        label="name"
                        class="form-control"
                        valueProp="uuid"
                        :options="personalityList"
                        placeholder="Per."
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-4 mb-2 form-group">
                    <label for="">Relations</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="relation"
                        v-model="detail.expectation.relation"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="relationList"
                        placeholder="Relations"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-4 mb-2 form-group">
                    <label for="">Eco. Status</label>
                    <div class="">
                      <Multiselect
                        mode="tags"
                        :searchable="true"
                        name="echo_status"
                        v-model="detail.expectation.echo_status"
                        trackBy="name"
                        label="name"
                        valueProp="uuid"
                        :options="echoStatusList"
                        placeholder="Eco. Status"
                        object="true"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 mb-2 form-group">
                    <label for="">Expected Educations</label>
                    <Field
                      as="textarea"
                      name="expected_educations"
                      placeholder="Expected Educations"
                      v-model="detail.expectation.expected_educations"
                      id=""
                      rows="2"
                      class="form-control h-auto"
                    ></Field>
                  </div> -->
                  <div class="col-md-6 mb-2 form-group">
                    <label for="">Expectations</label>
                    <Field
                      as="textarea"
                      name="occupation_other_expectations"
                      @keypress="$helperService.maxInput($event, 80)"
                      @keyup="
                        trimMaxLength(
                          'expectation.occupation_other_expectations',
                          80
                        )
                      "
                      placeholder="Expectations"
                      v-model="detail.expectation.occupation_other_expectations"
                      id=""
                      rows="2"
                      class="form-control h-auto"></Field>
                  </div>
                </div>
              </div>
              <div class="text-center mt-4">
                <button id="save-button111" class="btn btn-brand-1 me-3">
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-outline-brand-1"
                  v-on:click="$router.go(-1)">
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        </div>
        <ErrorComponent @retry="getDetail()" ref="errorComponent" />
      </div>
    </main>
    <!-- Modal Add Brother Sister -->

    <TextModal ref="BrotherSisterModal">
      <div class="modal-header">
        <h5 class="modal-title">Add Brother/Sister Details</h5>
        <button
          style="position: absolute"
          type="button"
          class="close"
          v-on:click="$refs.BrotherSisterModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="BrotherSisterForm" @submit="saveBrotherSister()">
        <div class="modal-body form-style">
          <div class="row">
            <div class="col-lg-12">
              <!-- <span style="font-size: 12px; font-weight: bold"
                >(if sister is married, mention surname only)</span
              > -->
            </div>
            <div class="col-lg-12">
              <div class="form-group">
                <label>First Name</label>
                &nbsp;
                <span style="font-size: 12px; font-weight: bold"
                  >(If sister is married, mention surname only)</span
                >

                <Field
                  type="text"
                  class="form-control"
                  name="name"
                  @keypress="$helperService.maxInput($event, 14)"
                  @keyup="trimMaxLength2('name', 14)"
                  v-model="brotherSisterObj.name"
                  placeholder="First Name" />
                <ErrorMessage
                  name="name"
                  class="text-danger"
                  style="display: inline; font-size: 15px" />
              </div>
            </div>

            <div class="form-group col-lg-12">
              <label for="inputRole">Married ?</label>
              <Field
                as="select"
                class="form-control form-select"
                id="is_married"
                name="is_married"
                v-model="brotherSisterObj.is_married">
                <option value="">Select Status</option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </Field>
              <ErrorMessage
                name="is_married"
                class="text-danger"
                style="display: inline; font-size: 15px" />
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>Education</label>
                <Field
                  type="text"
                  class="form-control"
                  name="education"
                  @keypress="$helperService.maxInput($event, 20)"
                  @keyup="trimMaxLength2('education', 20)"
                  v-model="brotherSisterObj.education"
                  placeholder="Education" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label>Occupation</label>
                <Field
                  type="text"
                  class="form-control"
                  @keypress="$helperService.maxInput($event, 19)"
                  @keyup="trimMaxLength2('occupation', 19)"
                  name="occupation"
                  v-model="brotherSisterObj.occupation"
                  placeholder="Occupation" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <div class="form-group">
              <label>Working Place</label>
              <Field
                type="text"
                class="form-control"
                name="working_place"
                @keypress="$helperService.maxInput($event, 17)"
                @keyup="trimMaxLength2('working_place', 17)"
                v-model="brotherSisterObj.working_place"
                placeholder="Working Place" />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="form-group">
                <label>Birth Year</label>

                <Field
                  type="text"
                  name="opening_date"
                  placeholder="Select birth year"
                  v-model="brotherSisterObj.birth_year"
                  v-slot="{ field }">
                  <Datepicker
                    autoApply
                    placeholder="Select Year"
                    v-model="brotherSisterObj.birth_year"
                    :maxDate="new Date()"
                    format="yyyy"
                    yearPicker
                    v-bind="field" />
                </Field>
              </div>
            </div>

            <div class="col-lg-6 col-sm-6 form-group">
              <label for="">Height</label>
              <Field
                as="select"
                class="form-control form-select"
                id="height"
                name="height"
                v-model="brotherSisterObj.height">
                <option value="">Select Height</option>
                <option value="139">
                  {{ $helperService.getHeight(139) }}
                </option>
                <option value="142">
                  {{ $helperService.getHeight(142) }}
                </option>
                <option value="144">
                  {{ $helperService.getHeight(144) }}
                </option>
                <option value="147">
                  {{ $helperService.getHeight(147) }}
                </option>
                <option value="149">
                  {{ $helperService.getHeight(149) }}
                </option>
                <option value="152">
                  {{ $helperService.getHeight(152) }}
                </option>
                <option value="154">
                  {{ $helperService.getHeight(154) }}
                </option>
                <option value="157">
                  {{ $helperService.getHeight(157) }}
                </option>
                <option value="160">
                  {{ $helperService.getHeight(160) }}
                </option>
                <option value="162">
                  {{ $helperService.getHeight(162) }}
                </option>
                <option value="165">
                  {{ $helperService.getHeight(165) }}
                </option>
                <option value="167">
                  {{ $helperService.getHeight(167) }}
                </option>
                <option value="170">
                  {{ $helperService.getHeight(170) }}
                </option>
                <option value="172">
                  {{ $helperService.getHeight(172) }}
                </option>
                <option value="175">
                  {{ $helperService.getHeight(175) }}
                </option>
                <option value="177">
                  {{ $helperService.getHeight(177) }}
                </option>
                <option value="180">
                  {{ $helperService.getHeight(180) }}
                </option>
                <option value="182">
                  {{ $helperService.getHeight(182) }}
                </option>
                <option value="185">
                  {{ $helperService.getHeight(185) }}
                </option>
                <option value="187">
                  {{ $helperService.getHeight(187) }}
                </option>
                <option value="190">
                  {{ $helperService.getHeight(190) }}
                </option>
                <option value="192">
                  {{ $helperService.getHeight(192) }}
                </option>
                <option value="195">
                  {{ $helperService.getHeight(195) }}
                </option>
                <option value="198">
                  {{ $helperService.getHeight(198) }}
                </option>
                <option value="200">
                  {{ $helperService.getHeight(200) }}
                </option>
                <option value="203">
                  {{ $helperService.getHeight(203) }}
                </option>
                <option value="205">
                  {{ $helperService.getHeight(205) }}
                </option>
                <option value="208">
                  {{ $helperService.getHeight(208) }}
                </option>
                <option value="210">
                  {{ $helperService.getHeight(210) }}
                </option>
                <option value="213">
                  {{ $helperService.getHeight(213) }}
                </option>
              </Field>
            </div>
          </div>
          <div class="col-md-12">
            <label for="">Rel.</label>
            <div class="row">
              <!-- <Field
                type="text"
                name="genderType"
                placeholder="Select birth year"
                v-model="brotherSisterObj.gender"
              > -->
              <div
                class="form-check col-lg-2"
                style="margin-left: 12px; margin-top: 6px">
                <input
                  class="form-check-input"
                  type="radio"
                  name="genderType"
                  id="male"
                  value="M"
                  v-model="brotherSisterObj.gender" />
                <label class="form-check-label" for="male">Bro</label>
              </div>
              <div class="form-check col-lg-2" style="margin-top: 6px">
                <input
                  class="form-check-input"
                  type="radio"
                  name="genderType"
                  id="female"
                  value="F"
                  v-model="brotherSisterObj.gender" />
                <label class="form-check-label" for="female"> Sis </label>
              </div>
              <!-- </Field> -->
            </div>
          </div>
        </div>
        <div class="modal-footer" style="display: inherit">
          <button id="Brother_Sister" class="btn btn-brand-1 me-3">Save</button>
          <button
            type="button"
            class="btn btn-outline-brand-1"
            id="cancel-button"
            v-on:click="$refs.BrotherSisterModal.closeModal">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>

    <!-- Mobile Modal -->
    <TextModal ref="MobileModal">
      <div class="modal-header">
        <h5 class="modal-title">
          Change {{ type == "CHANGE_NUMBER" ? "Mobile Number" : "Email" }}
        </h5>
        <button
          type="button"
          style="margin-top: -39px"
          class="close"
          v-on:click="$refs.MobileModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="MobileForm" @submit="saveMobileNumber()">
        <div class="modal-body form-style">
          <div class="col-lg-12 col-sm-12 row" v-if="type == 'CHANGE_NUMBER'">
            <div class="col-lg-12">
              <div class="form-group">
                <label>Mobile Number</label>
                <span class="text-danger">*</span>
                <Field
                  type="text"
                  name="edit_phone"
                  placeholder="Phone Number"
                  v-slot="{ field }"
                  v-model="mobile_no"
                  class="form-control mobile_no"
                  rules="required:Mobile Number"
                  :validateOnInput="true"
                  disabled>
                  <PhoneCode
                    id="mobile"
                    placeholder="Mobile Number"
                    v-model:countryCode="country_code"
                    v-model="mobile_no"
                    v-model:dialCode="mobile_country_code"
                    v-bind="field" />
                </Field>
                <ErrorMessage name="edit_phone" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12 row" v-else>
            <div class="col-lg-12">
              <div class="form-group">
                <label>Email</label>
                <span class="text-danger">*</span>
                <Field
                  type="text"
                  class="form-control"
                  name="edit_email"
                  v-model="email"
                  placeholder="Email"
                  rules="required:Email|email"
                  :validateOnInput="true" />
                <ErrorMessage name="edit_email" class="text-danger" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="display: inherit">
          <button id="edit_phone" class="btn btn-brand-1 me-3">Save</button>
          <button
            type="button"
            class="btn btn-outline-brand-1"
            id="cancel-button"
            v-on:click="$refs.MobileModal.closeModal">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>

    <!-- Properties Modal -->
    <TextModal ref="PropertiesModal">
      <Form ref="propertiesForm" @submit="saveProperty()">
        <div class="modal-header">
          <h5 class="modal-title">Add Properties</h5>
          <button
            style="position: absolute"
            type="button"
            class="close"
            v-on:click="$refs.PropertiesModal.closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body form-style pb-1">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <label for="">Property Name</label>
                <Field
                  type="text"
                  class="form-control"
                  name="property_name"
                  v-model="propertyObj.details"
                  placeholder="Property Name"
                  rules="required:Property Name"
                  :validateOnInput="true" />
                <ErrorMessage name="property_name" class="text-danger" />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group">
                <label for="">Property Place</label>
                <Field
                  type="text"
                  class="form-control"
                  name="property_place"
                  v-model="propertyObj.place"
                  placeholder="Property Place" />
                <!-- <ErrorMessage name="property_place" class="text-danger" /> -->
              </div>
            </div>

            <div class="modal-footer" style="display: inherit">
              <button id="property" class="btn btn-brand-1 me-3">Save</button>
              <button
                type="button"
                class="btn btn-outline-brand-1"
                id="cancel-button"
                v-on:click="$refs.PropertiesModal.closeModal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Form>
    </TextModal>

    <!-- Otp Modal -->
    <TextModal ref="otpModel">
      <div class="modal-dialog modal-dialog-centered" style="margin: 0px">
        <div class="modal-content">
          <div class="modal-header px-md-5 border-0">
            <h5 class="modal-title" id="loginModalLabel">OTP Confirmation</h5>
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.otpModel.closeModal"></button>
          </div>
          <div class="modal-body pt-0 text-center">
            <Form ref="otpForm" @Submit="verifyOtp()">
              <div class="form-group otp-element mb-0 col-md-10 mx-auto mb-4">
                <div class="text-center mb-4 digit-group">
                  <Field
                    id="codeBox_1"
                    type="text"
                    name="otp1"
                    class="otp-control"
                    maxlength="1"
                    rules="required"
                    validateOnInput="true"
                    v-on:keyup="onKeyUpEvent(1, $event)"
                    v-on:keyup.enter="verifyOtp()"
                    v-on:focus="onFocusEvent(1)" />
                  <Field
                    id="codeBox_2"
                    type="text"
                    name="otp2"
                    class="otp-control"
                    maxlength="1"
                    rules="required"
                    :validateOnInput="true"
                    v-on:keyup="onKeyUpEvent(2, $event)"
                    v-on:keyup.enter="verifyOtp()"
                    v-on:focus="onFocusEvent(2)" />
                  <Field
                    id="codeBox_3"
                    type="text"
                    name="otp3"
                    class="otp-control"
                    maxlength="1"
                    rules="required"
                    :validateOnInput="true"
                    v-on:keyup="onKeyUpEvent(3, $event)"
                    v-on:keyup.enter="verifyOtp()"
                    v-on:focus="onFocusEvent(3)" />
                  <Field
                    id="codeBox_4"
                    type="text"
                    name="otp4"
                    class="otp-control"
                    maxlength="1"
                    rules="required:OTP"
                    :validateOnInput="true"
                    v-on:keyup="onKeyUpEvent(4, $event)"
                    v-on:keyup.enter="verifyOtp()"
                    v-on:focus="onFocusEvent(4)" />
                </div>
                <ErrorMessage name="otp4" class="text-danger" />
                <div class="verification mb-4" style="margin-top: 16px">
                  We will send verification code on your registered email
                </div>
                <div class="text-center mb-4">
                  <button
                    class="btn btn-brand-1 btn-block"
                    id="verify-otp-button">
                    Verify
                  </button>
                </div>
                <div class="verification">
                  Didn’t Get the code?
                  <a class="font-weight-bold"
                    ><a
                      style="cursor: pointer"
                      id="resend-button"
                      v-on:click="saveMobileNumber('RESEND')"
                      >Resend</a
                    ></a
                  >.
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </TextModal>
  </div>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import moment from "moment";
import CustomDatepicker from "@/components/DatePicker.vue";
import Multiselect from "@vueform/multiselect";
import TextModal from "@/components/TextModal";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import ErrorComponent from "@/components/ErrorComponent";
import PhoneCode from "@/components/PhoneCodePicker/PhoneCode.vue";
export default {
  name: "EditProfile",
  components: {
    ErrorComponent,
    Multiselect,
    Datepicker,
    TextModal,
    Form,
    Field,
    CustomDatepicker,
    ErrorMessage,
    PhoneCode,
  },
  data() {
    return {
      loader: false,
      email: "",
      mobile_no: "",
      mobile_country_code: "",
      country_code: "",
      type: "",
      brotherSisterObj: {
        name: "",
        is_married: "",
        education: "",
        occupation: "",
        working_place: "",
        birth_year: "",
        height: "",
        gender: "",
      },
      propertyObj: {
        details: "",
        place: "",
      },
      phoneObj: {
        phone: "",
      },
      detail: {
        birth_time: "",
        native_place_district_id: "",
        native_place_taluka_id: "",
        height: "",
        native_place_goan: "",
        dob: "",
        family_details: {
          relatives: [
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
          ],
          family_members: [],
          familty_phone_numbers: [
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
          ],
        },
        expectation: {
          move_to_abroad: [],
          birth_year_from: "",
          birth_year_to: "",
          height_from: "",
          height_to: "",
          expected_educations: "",
          occupation_other_expectations: "",
          marital_status: [],
          occupation_type: [],
          body_structure: [],
          diet: [],
          education_group: [],
          working_city: [],
          native_district: [],
          family_residence: [],
          working_country: [],
          personality: [],
          relation: [],
          echo_status: [],
        },
        user_properties: [{}, {}, {}, {}],
      },
      nativeTalukaList: [],
      districtList: [],
      countryList: [],
      body_structure: [],
      marriedStatusList: [],
      skin_tone: [],
      diet: [],
      educationGroupList: [],
      occupation_type: [],
      occupationTypeList: [],
      relationList: [],
      personalityList: [],
      echoStatusList: [],
      raas: [],
      nakshatra: [],
      charan: [],
      nadi: [],
      gan: [],
      taluka: [],
      work_location: [],
      district: [],
      stateList: [],
      moveToAbroadList: [],
      devakList: [],
    };
  },
  mounted() {
    this.getDevak("DEVAK");
    this.getBodyStructure("BODY_STRUCTURE");
    this.getSkinTone("SKIN_TONE");
    this.getDiet("DIET");
    this.getEducationGroup("EDUCATION_GROUP");
    this.getOccupationType("OCCUPATION_TYPE");
    this.getRaas("RAAS");
    this.getNakshtra("NAKSHTRA");
    this.getNadi("NADI");
    this.getGan("GAN");
    this.getStatusList("MARITAL_STATUS");
    this.getOccupationList("OCCUPATION_TYPE");
    this.getRelationList("RELATION");
    this.getEchostateList("ECO_STATUS");
    this.getpersonalityList("PERSONALITY");
    this.getMoveToAbroadList("MOVE_TO_ABROAD");
    this.getCharan();
    this.getStateList();
    this.getDistrict();
    this.getTaluka();
    this.getWorkLocation();
    this.getTalukaList();
    this.getDistrictList();
    this.getCountryList();
    this.getDetail();
    if (window.location.pathname == "/edit-profile") {
      window.scrollTo(0, 0);
    }
  },
  methods: {
    trimMaxLengthGlobal(id, limit) {
      document.getElementById(id).value = document.getElementById(id).value.substring(0, limit);
    },
    trimMaxLength(key, limit) {
      var field = key.split(".")[0];
      var field2 = key.split(".")[1];
      if (field && field2) {
        if (
          this.detail[field] &&
          this.detail[field][field2] &&
          this.detail[field][field2].length > limit
        ) {
          this.detail[field][field2] = this.detail[field][field2].substring(
            0,
            limit
          );
        }
      } else {
        if (this.detail[field] && this.detail[field].length > limit) {
          this.detail[field] = this.detail[field].substring(0, limit);
        }
      }
    },
    trimMaxLength2(field, limit) {
      if (
        this.brotherSisterObj[field] &&
        this.brotherSisterObj[field].length > limit
      ) {
        this.brotherSisterObj[field] = this.brotherSisterObj[field].substring(
          0,
          limit
        );
      }
    },
    getMoveToAbroadList(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.moveToAbroadList = res.list;
        })
        .catch(() => {});
    },
    getRelationList(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.relationList = res.list;
        })
        .catch(() => {});
    },
    getEchostateList(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.echoStatusList = res.list;
        })
        .catch(() => {});
    },
    updateWhatsappFlag(data) {
      if (data.is_whatsapp == "N") {
        return (data.is_whatsapp = "Y");
      } else {
        return (data.is_whatsapp = "N");
      }
    },
    updateCallFlag(data) {
      if (data.is_phone == "N") {
        return (data.is_phone = "Y");
      } else {
        return (data.is_phone = "N");
      }
    },
    getpersonalityList(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.personalityList = res.list;
        })
        .catch(() => {});
    },
    getTalukaList() {
      this.$api
        .getAPI({
          _action: "/taluka/list",
        })
        .then((res) => {
          this.nativeTalukaList = res;
        })
        .catch(() => {});
    },
    getWorkLocation() {
      this.$api
        .getAPI({
          _action: "/work-location/list",
        })
        .then((res) => {
          this.work_location = res;
        })
        .catch(() => {});
    },
    getDistrictList() {
      this.$api
        .getAPI({
          _action: "/district/list",
        })
        .then((res) => {
          this.districtList = res;
        })
        .catch(() => {});
    },
    getCountryList() {
      this.$api
        .getAPI({
          _action: "/country/list",
        })
        .then((res) => {
          this.countryList = res;
        })
        .catch(() => {});
    },
    getDetail() {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateFormLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          if (!res.family_details) {
            res.family_details = {};
          }

          if (res.family_details.relatives.length == 0) {
            res.family_details.relatives = [
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
            ];
          }
          if (res.family_details && res.family_details.relatives.length > 5) {
            for (var z in res.family_details.relatives) {
              if (z > 4) {
                res.family_details.relatives.splice(1, z);
              }
            }
          }
          if (res.birth_time) {
            var time = res.birth_time.split(":");
            res.birth_time = {
              hours: time[0],
              minutes: time[1],
              seconds: time[2],
            };
          }
          this.detail = res;

          if (!this.detail.brotherSisterObj) {
            this.detail.brotherSisterObj = {};
          }
          if (!this.detail.email) {
            this.detail.email = "";
          }
          if (!this.detail.propertyObj) {
            this.detail.propertyObj = {};
          }
          if (!this.detail.phoneObj) {
            this.detail.phoneObj = {};
          }
          if (this.detail.expectation == null) {
            this.detail.expectation = {
              marital_status: [],
            };
          }
          if (
            this.detail.family_details &&
            this.detail.family_details.familty_phone_numbers.length == 0
          ) {
            this.detail.family_details.familty_phone_numbers.push(
              {
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              },
              {
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              },
              {
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              }
            );
          } else if (
            this.detail.family_details &&
            this.detail.family_details.familty_phone_numbers.length < 3
          ) {
            const length =
              this.detail.family_details.familty_phone_numbers.length;
            for (var ff = 0; ff < 3 - length; ff++) {
              this.detail.family_details.familty_phone_numbers.push({
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              });
            }
          }
          // this.detail = res;
          res.opening_date = moment(this.detail.opening_date).format(
            "DD MMM YYYY "
          );
          if (this.detail.user_properties.length < 4) {
            const length = this.detail.user_properties.length;
            for (var qq = 0; qq < 4 - length; qq++) {
              this.detail.user_properties.push({
                details: "",
                place: "",
              });
            }
          }
          this.$refs.dobDatePicker.setDateValueData(this.detail.dob);
          this.getCharan(this.detail.nakshatra_id);
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateFormLoader(false);
          }
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    getStateList() {
      this.$api
        .getAPI({
          _action: "/state/list",
        })
        .then((res) => {
          this.stateList = res;
        })
        .catch(() => {});
    },
    getOccupationList(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.occupationTypeList = res.list;
        })
        .catch(() => {});
    },
    getStatusList(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.marriedStatusList = res.list;
        })
        .catch(() => {});
    },
    getBodyStructure(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.body_structure = res.list;
        })
        .catch(() => {});
    },
    getDevak(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.devakList = res.list;
        })
        .catch(() => {});
    },
    removeBrotherSister(index) {
      this.detail.family_details.family_members.splice(index, 1);
    },
    editBrotherSister(index) {
      var obj = {
        name: this.detail.family_details.family_members[index].name,
        is_married: this.detail.family_details.family_members[index].is_married,
        education: this.detail.family_details.family_members[index].education,
        occupation: this.detail.family_details.family_members[index].occupation,
        working_place:
          this.detail.family_details.family_members[index].working_place,
        birth_year: this.detail.family_details.family_members[index].birth_year,
        height: this.detail.family_details.family_members[index].height,
        gender: this.detail.family_details.family_members[index].gender,
        indx: index,
      };
      this.brotherSisterObj = obj;
      this.$refs.BrotherSisterModal.showModal();
    },
    getSkinTone(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.skin_tone = res.list;
        })
        .catch(() => {});
    },
    getDiet(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.diet = res.list;
        })
        .catch(() => {});
    },
    getEducationGroup(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.educationGroupList = res.list;
          this.education_group = res.list;
        })
        .catch(() => {});
    },
    changeBOD(e) {
      var date = new Proxy(e, {}).date;
      this.detail.dob = date.format("YYYY-MM-DD");
    },
    getOccupationType(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.occupation_type = res.list;
        })
        .catch(() => {});
    },
    getRaas(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.raas = res.list;
        })
        .catch(() => {});
    },
    getNakshtra(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.nakshatra = res.list;
        })
        .catch(() => {});
    },
    getCharan(nakshatra_id) {
      var obj = {};
      if (nakshatra_id) {
        obj.nakshatra_id = nakshatra_id;
      }
      obj.type = "CHARAN";
      this.$api
        .getAPI({
          _action: "/master-data/list",
          _body: obj,
        })
        .then((res) => {
          this.charan = res.list;
        })
        .catch(() => {});
    },
    getNadi(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.nadi = res.list;
        })
        .catch(() => {});
    },
    getGan(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.gan = res.list;
        })
        .catch(() => {});
    },
    getDistrict() {
      this.$api
        .getAPI({
          _action: "/district/list",
        })
        .then((res) => {
          this.district = res;
        })
        .catch(() => {});
    },
    getTaluka() {
      this.$api
        .getAPI({
          _action: "/taluka/list",
        })
        .then((res) => {
          this.taluka = res;
        })
        .catch(() => {});
    },
    update() {
      if (this.detail.birth_time) {
        this.detail.birth_time = moment(this.detail.birth_time).format(
          "HH:mm:ss"
        );
      }
      var obj = {};
      obj.detail = this.detail;
      this.detail.devak = this.detail.devak_id;
      this.$api
        .putAPI({
          _action: "/edit/profile",
          _body: this.detail,
          _buttonId: "save-button111",
        })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    },
    showBrotherSisterPopup() {
      this.brotherSisterObj = {};
      this.brotherSisterObj.indx = null;
      this.$refs.BrotherSisterForm.resetForm();
      this.brotherSisterObj.gender = "";
      this.$refs.BrotherSisterModal.showModal();
    },
    saveEmail() {
      var obj = {
        email: this.email,
      };
      if (this.email) {
        obj.email = this.email;
      }
      this.detail.email = this.email;
      // this.$refs.EmailModal.closeModal();
      this.showOtpModel();
    },
    showMobilePopup(type) {
      this.type = type;
      if (type == "CHANGE_NUMBER") {
        this.mobile_no = this.detail.mobile;
        this.mobile_country_code = this.detail.mobile_country_code;
        this.country_code = this.detail.country_code;
      } else {
        this.email = this.detail.email;
      }
      this.$refs.MobileModal.showModal();
    },
    saveMobileNumber(type) {
      var obj = {};
      if (this.type == "CHANGE_NUMBER") {
        obj.email = this.mobile_no;
        obj.mobile_country_code = this.mobile_country_code;
        obj.country_code = this.country_code;
      } else {
        obj.email = this.email;
      }
      if (type) {
        obj.otp_type = "RESEND";
      }
      obj.type = this.type;
      this.$api
        .postAPI({
          _action: "/resend/otp",
          _body: obj,
          _buttonId: "resend-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          if (res.success) {
            this.$refs.MobileModal.closeModal();
            this.$refs.otpModel.showModal();
          }
        })
        .catch(() => {});
    },
    verifyOtp() {
      var obj = {};
      if (this.type == "CHANGE_NUMBER") {
        obj.email = this.mobile_no;
        obj.mobile_country_code = this.mobile_country_code;
        obj.country_code = this.country_code;
      } else {
        obj.email = this.email;
      }
      obj.type = this.type;
      obj.otp =
        document.getElementById("codeBox_1").value +
        "" +
        document.getElementById("codeBox_2").value +
        "" +
        document.getElementById("codeBox_3").value +
        "" +
        document.getElementById("codeBox_4").value;
      if (obj.otp.length == 4) {
        this.$api
          .putAPI({
            _action: "/verify/otp",
            _body: obj,
            _buttonId: "verify-otp-button",
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$refs.otpModel.closeModal();
            this.$refs.otpForm.resetForm();
            this.getDetail();
          })
          .catch(() => {});
      } else {
        this.validate = true;
      }
    },
    onFocusEvent(index) {
      if (index < 4) {
        for (var item = 1; item < index; item++) {
          const currentElement = this.getCodeBoxElement(item);
          if (!currentElement.value) {
            currentElement.focus();
            break;
          }
        }
      }
    },
    getCodeBoxElement(index) {
      return document.getElementById("codeBox_" + index);
    },
    onKeyUpEvent(index, event) {
      if (index < 4) {
        const eventCode = event.which || event.keyCode;
        if (this.getCodeBoxElement(index).value.length === 1) {
          if (index !== 4) {
            this.getCodeBoxElement(index + 1).focus();
          } else {
            this.getCodeBoxElement(index).blur();
          }
        }
        if (eventCode === 8 && index !== 1) {
          this.getCodeBoxElement(index - 1).focus();
        }
      }
    },
    saveBrotherSister() {
      var obj = {
        name: this.brotherSisterObj.name,
        is_married: this.brotherSisterObj.is_married,
        education: this.brotherSisterObj.education,
        occupation: this.brotherSisterObj.occupation,
        working_place: this.brotherSisterObj.working_place,
        birth_year: this.brotherSisterObj.birth_year,
        height: this.brotherSisterObj.height,
        gender: this.brotherSisterObj.gender,
        indx: null,
      };
      if (this.brotherSisterObj.indx != null) {
        for (var i in this.detail.family_details.family_members) {
          if (i == this.brotherSisterObj.indx) {
            this.detail.family_details.family_members[i] =
              this.brotherSisterObj;
          }
        }
      } else {
        this.detail.family_details.family_members.push(obj);
      }

      this.$refs.BrotherSisterModal.closeModal();
    },
    showPropertiesPopup() {
      this.$refs.propertiesForm.resetForm();
      this.$refs.PropertiesModal.showModal();
    },
    removevideoObj(data, index) {
      if (data.uuid) {
        this.$api
          .deleteAPI({
            _action: "/remove-property/" + data.uuid,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getDetail();
          })
          .catch(() => {});
      } else {
        this.detail.user_properties.splice(index, 1);
      }
    },
    saveProperty() {
      var obj = {
        details: this.propertyObj.details,
        place: this.propertyObj.place,
      };
      this.detail.user_properties.push(obj);
      this.$refs.PropertiesModal.closeModal();
    },
  },
};
</script>
<style scoped>
.multiselect {
  /* background: white !important; */
  height: auto !important;
  border: 1px solid;
}

.multiselect-tag {
  background: #d35bc1 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}
</style>
